module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA13.36657b34.jpg";